import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import { Modal, Button } from "react-bootstrap";

function SignUp() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [showModal, setShowModal] = useState(false); // State for modal
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    // Use env variable if present, otherwise fallback to localhost backend
    const BACKEND_URL = process.env.REACT_APP_BACKEND || "http://localhost:8000";

    const validatePassword = (password) => {
        const minLength = 8;
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);

        return (
            password.length >= minLength &&
            hasSpecialChar &&
            hasUpperCase &&
            hasLowerCase &&
            hasNumber
        );
    };

    const validatePasswordDetailed = (password) => {
        const errors = [];
        if (password.length < 8) {
            errors.push("Password must be at least 8 characters long.");
        }
        if (!/[A-Z]/.test(password)) {
            errors.push("Password must include at least one uppercase letter.");
        }
        if (!/[a-z]/.test(password)) {
            errors.push("Password must include at least one lowercase letter.");
        }
        if (!/[0-9]/.test(password)) {
            errors.push("Password must include at least one number.");
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
            errors.push("Password must include at least one special character.");
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (password !== confirmPassword) {
            setError("Passwords do not match!");
            return;
        }

        const passwordErrors = validatePasswordDetailed(password);
        if (passwordErrors.length > 0) {
            setError(passwordErrors[0]); // Show the first specific error
            return;
        }

        try {
            // use relative path; api.baseURL handles the host
            const response = await api.post("/api/auth/register", {
                name,
                email,
                password,
            });
            console.log("register response:", response && response.data);
            setShowModal(true);
        } catch (err) {
            // show any server-provided message to help debug CORS/response issues
            console.error("register error:", err.response || err.message || err);
            setError(
                (err.response && err.response.data && err.response.data.message) ||
                    "Registration failed. Please try again."
            );
        }
    };

    const getPasswordStrength = (password) => {
        let strength = 0;
        if (password.length >= 8) strength += 20;
        if (/[a-z]/.test(password)) strength += 20;
        if (/[A-Z]/.test(password)) strength += 20;
        if (/[0-9]/.test(password)) strength += 20;
        if (/[^A-Za-z0-9]/.test(password)) strength += 20;
        return strength;
    };

    const passwordStrength = getPasswordStrength(password);

    return (
        <div className="signup-page-container d-flex justify-content-end align-items-start" style={{ padding: '2rem' }}>
            <div className="text-end" style={{ maxWidth: '400px', width: '90%' }}>
                <div>
                    <h1 className="signup-title">
                        <span className="signup-title-dark px-2 py-1 rounded">Tn</span> Taxi Project
                    </h1>
                </div>

                <div className="signup-card">
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="name"><h2><strong className="text-dark">Registration</strong></h2></label>

                        <div className="mb-3">
                            <label htmlFor="name"><strong className="text-dark">Name</strong></label>
                            <input
                                type="text"
                                placeholder="Enter your name"
                                autoComplete="off"
                                className="form-control rounded-0"
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="email"><strong>Email</strong></label>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                autoComplete="off"
                                className="form-control rounded-0"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="mb-3 position-relative">
                            <label htmlFor="password"><strong>Password</strong></label>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                autoComplete="off"
                                className="form-control rounded-0"
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <i
                                className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    top: "38px",
                                    right: "15px",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                }}
                            ></i>
                        </div>

                        <div className="password-strength-bar mt-1">
                            <div
                                className="password-strength-fill"
                                style={{
                                    width: `${passwordStrength}%`,
                                    backgroundColor:
                                        passwordStrength < 40 ? "red" :
                                        passwordStrength < 80 ? "yellow" : "green",
                                }}
                            ></div>
                        </div>

                        <div className="mb-3 position-relative">
                            <label htmlFor="confirmPassword"><strong>Confirm Password</strong></label>
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm your password"
                                autoComplete="off"
                                className="form-control rounded-0"
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <i
                                className={`bi ${showConfirmPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{
                                    top: "38px",
                                    right: "15px",
                                    cursor: "pointer",
                                    color: "#6c757d",
                                }}
                            ></i>
                        </div>

                        {error && <p className="text-danger">{error}</p>}

                        <button type="submit" className="btn btn-dark w-100 rounded-0">
                            Register
                        </button>
                    </form>

                    <p className="mt-2">Already have an account?</p>
                    <Link to="/" className="btn btn-light w-100 rounded-0 text-decoration-none">
                        Login
                    </Link>
                </div>
            </div>

            {/* Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header className="bg-warning">
                    <Modal.Title>Registration successful</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to go to the login page?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="dark" onClick={() => navigate("/")}>OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default SignUp;
